/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PurchaserCompanyState = 'Leading' | 'Participant' | 'Invited';

export const PurchaserCompanyState = {
    Leading: 'Leading' as PurchaserCompanyState,
    Participant: 'Participant' as PurchaserCompanyState,
    Invited: 'Invited' as PurchaserCompanyState
};

